import {Injectable, NgZone} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {GeneralConstant} from '../constants/GeneralConstant';
import {RestResponse} from '../models/http/RestResponse.model';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class ResponseSnackbarService {
  constructor(private snackBar: MatSnackBar, private zone: NgZone) {
  }

  public onResponse(response) {
    response = (response instanceof HttpErrorResponse ? response.error : response) as RestResponse<any>;

    const successClass = 'I';
    const warningClass = 'W';
    const errorClass = 'E';
    let type;
    let panelClass;

    if (response.code) {
      const codeType = response.code.split('-');
      if (codeType.length > 1) {
        type = codeType[1];
      }
    }

    switch (type) {
      case successClass:
        panelClass = GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS;
        break;
      case warningClass:
        panelClass = GeneralConstant.SNACKBAR_RES_WARNING_CLASS;
        break;
      case errorClass:
        panelClass = GeneralConstant.SNACKBAR_RES_ERROR_CLASS;
        break;

      default:
        if (response.success) {
          panelClass = GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS;
        } else {
          panelClass = GeneralConstant.SNACKBAR_RES_ERROR_CLASS;
        }
        break;
    }

    this.onResponseMessage(response.message, panelClass);
  }

  public onResponseMessage(message, panelClass, duration?: number) {
    if (!message || message === '') {
      if (panelClass === GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS) {
        message = 'Success!';
      } else {
        message = 'An unknown error occurred. Please try again!';
      }
    }
    this.zone.run(() => {
      this.snackBar.open(message, 'x', {
        panelClass: [panelClass],
        duration: duration || GeneralConstant.SNACKBAR_DURATION
      });
    });
  }
}
